import { FC } from 'react';

import { Divider as DividerLine } from './Divider.styles';

const Divider: FC = (props) => <DividerLine {...props} />;

export { Divider };
